import { normalizeMemberTypes } from '@/domain/memberTypes'
import {
  LUSSO_MEMBER_TYPES,
  MEMBER_TYPES,
  PROFILE_TYPES,
  R4U_MEMBER_TYPES
} from '@/domain/MyAccount'
import { userTypes } from '@/infrastructure/Configuration'

const R4U_TYPES = new Set([...R4U_MEMBER_TYPES, ...LUSSO_MEMBER_TYPES, 'pcr', 'tmc'])
const R4U_PROFILE_TYPES = new Set([
  PROFILE_TYPES.PCR_ADMIN,
  PROFILE_TYPES.PCR_MEMBER,
  PROFILE_TYPES.TMC_ADMIN,
  PROFILE_TYPES.TMC_MEMBER
])

const PROFILE_TO_MEMBER_TYPE = {
  [PROFILE_TYPES.PCR_ADMIN]: MEMBER_TYPES.PCR_ADMIN,
  [PROFILE_TYPES.PCR_MEMBER]: MEMBER_TYPES.PCR_BOOKER,
  [PROFILE_TYPES.TMC_ADMIN]: MEMBER_TYPES.TMC_ADMIN,
  [PROFILE_TYPES.TMC_MEMBER]: MEMBER_TYPES.TMC_BOOKER
}

const getProfileTypes = customer =>
  String(customer?.profileType || '')
    .toUpperCase()
    .split('|')
    .map(type => type.trim())
    .filter(Boolean)

const getRoleTypes = customer => {
  const memberTypes = normalizeMemberTypes(customer)
  const profileTypes = getProfileTypes(customer)
  const extendedCode = String(customer?.memberTypeExtended?.code || '').toLowerCase()
  const extendedName = String(customer?.memberTypeExtended?.name || '').toLowerCase()
  const roles = new Set(memberTypes)

  profileTypes.forEach(type => {
    if (
      type === PROFILE_TYPES.B2B_TRAVEL_AGENT ||
      type === PROFILE_TYPES.B2B_MEETINGS_AND_EVENTS
    ) {
      roles.add(type === PROFILE_TYPES.B2B_TRAVEL_AGENT ? 'b2b_ta' : 'b2b_me')
    }
    if (R4U_PROFILE_TYPES.has(type)) {
      roles.add(PROFILE_TO_MEMBER_TYPE[type])
    }
  })

  const profileType = getProfileTypes(customer).join('|')
  if (profileType.includes('PCR')) roles.add('pcr')
  if (profileType.includes('TMC')) roles.add('tmc')

  memberTypes.forEach(type => {
    if (type === userTypes.TRAVEL_AGENT) roles.add('b2b_ta')
    if (type === userTypes.TRAVEL_ARRENGER) roles.add('b2b_travel_arranger')
    if (type === userTypes.MEETINGS_AND_EVENTS) roles.add('b2b_me')
  })

  if (extendedCode.includes(userTypes.TRAVEL_AGENT)) roles.add('b2b_ta')
  if (extendedCode.includes(userTypes.TRAVEL_ARRENGER)) roles.add('b2b_travel_arranger')
  if (extendedCode.includes(userTypes.MEETINGS_AND_EVENTS)) roles.add('b2b_me')
  if (extendedName.includes('travel agent')) roles.add('b2b_ta')
  if (extendedName.includes('travel arranger')) roles.add('b2b_travel_arranger')
  if (extendedName.includes('meetings and events')) roles.add('b2b_me')

  return roles
}

export const hasR4UAccess = customer => {
  const roles = getRoleTypes(customer)
  const r4uRoles = [...roles].filter(role => R4U_TYPES.has(role))

  if (r4uRoles.length === 0) return false

  const hasB2BTa = roles.has('b2b_ta')
  const hasOtherR4UProgram = new Set(r4uRoles.map(role => role.split('_')[0])).size > 1

  return !hasB2BTa && !hasOtherR4UProgram
}
